import styled from 'styled-components';

export const SuturesDetailsContainer = styled.div`
  background-color: #F4F8FF;
  padding-bottom: 48px;
`;

export const TableContainer = styled.div`
  padding: 36px 60px;

  @media (max-width: 900px) {
    padding: 30px 40px;
  }

  @media (max-width: 499px) {
    padding: 12px 14px;
    padding-top: 24px;
  }
`;

export const TableHeading = styled.div`
  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 48px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  margin-bottom: 56px;

  @media (max-width: 599px) {
    font-size: 38px;
    margin-bottom: 48px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }
      
  tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
`;

export const TableHeader = styled.tr`
  background: rgba(247, 147, 30, 0.2);
  text-align: center;

  th {
    padding: 28px;
    font-weight: 600;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }
      
  th:last-child {
    border-top-right-radius: 10px;
  }
`;

export const TableRow = styled.tr<{ alt?: boolean }>`
  background: ${({ alt }) => (alt ? '#F5F8FA' : 'white')};

  td {
    padding: 28px;
    // font-size: 14px;
  }
`;

export const TableData = styled.td<{ bold?: boolean }>`
  font-weight: ${({ bold }) => (bold ? '700' : '400')};
`;

export const CTAButton = styled.button`
  margin: 2rem auto 0;
  display: block;
  padding: 12px 24px;
  background: white;
  color: #000;
  font-weight: 600;
  font-size: 16px;
  border: 2px solid #f7941d;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.2s ease;
  margin-top: 14px;

  &:hover {
    background: #f7941d;
    color: white;
  }
`;
